export default __webpack_public_path__ + "static/media/Mark-3-HUD-04.71a5bd0f.jpg";